export const throwback = [
  {
    number: 'TB100',
    hasModel: true,
  },
  {
    number: 'TB101',
    hasModel: true,
  },
  {
    number: 'TB102',
    hasModel: true,
  },
  {
    number: 'TB103',
    hasModel: false,
  },
  {
    number: 'TB104',
    hasModel: true,
  },
  {
    number: 'TB105',
    hasModel: true,
  },
  {
    number: 'TB107',
    hasModel: true,
  },
  {
    number: 'TB108',
    hasModel: false,
  },
  {
    number: 'TB109',
    hasModel: false,
  },
  {
    number: 'TB110',
    hasModel: true,
  },
  {
    number: 'TB111',
    hasModel: true,
  },
  {
    number: 'TB112',
    hasModel: true,
  },
  {
    number: 'TB113',
    hasModel: true,
  },
  {
    number: 'TB114',
    hasModel: false,
  },
  {
    number: 'TB115',
    hasModel: false,
  },
  {
    number: 'TB116',
    hasModel: false,
  },
  {
    number: 'TB117',
    hasModel: false,
  },
  {
    number: 'TB118',
    hasModel: true,
  },
  {
    number: 'TB119',
    hasModel: true,
  },
  {
    number: 'TB121',
    hasModel: false,
  },
  {
    number: 'TB123',
    hasModel: false,
  },
  {
    number: 'TB124',
    hasModel: true,
  },
  {
    number: 'TB126',
    hasModel: false,
  },
  {
    number: 'TB127',
    hasModel: true,
  },
  {
    number: 'TB128',
    hasModel: false,
  },
  {
    number: 'TB129',
    hasModel: false,
  },
  {
    number: 'TB130',
    hasModel: false,
  },
  {
    number: 'TB131',
    hasModel: true,
  },
  {
    number: 'TB132',
    hasModel: true,
  },
  {
    number: 'TB133',
    hasModel: true,
  },
  {
    number: 'TB135',
    hasModel: false,
  },
  {
    number: 'TB137',
    hasModel: true,
  },
  {
    number: 'TB139',
    hasModel: true,
  },
  {
    number: 'TB140',
    hasModel: false,
  },
  {
    number: 'TB141',
    hasModel: false,
  },
  {
    number: 'TB142',
    hasModel: false,
  },
  {
    number: 'TB145',
    hasModel: false,
  },
  {
    number: 'TBX',
    hasModel: false,
  },
];
